import { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { afterSignApplication as triggerNextStateAfterSigning } from '../../api/application';
import { ConsumerLoanTargetPath } from '../../domain/types';
import { ConsumerLoanParameter } from '../../domain/types/ConsumerLoanParameter';
import { getPath } from '../../helpers/url';
import { useAuthentication } from '../../hooks/useAuthentication';
import useSettings from '../../hooks/useSettings';
import StatusProcessingPage from '../StatusPage/ProcessingPage/StatusProcessingPage';

const CallbackPage = () => {
    const { languageCode, countryCode, apiKey, proxyBaseUrl } = useSettings();
    useAuthentication();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const params = useParams();

    useEffect(() => {
        const callbackStatus = searchParams.get(ConsumerLoanParameter.callbackStatus);
        const applicationReferenceNumber = params[ConsumerLoanParameter.applicationReferenceNumber] ?? '';

        if (!applicationReferenceNumber) {
            return;
        }

        if (callbackStatus === 'success') {
            triggerNextStateAfterSigning({
                countryCode: countryCode,
                languageCode: languageCode,
                apiKey: apiKey,
                proxyBaseUrl: proxyBaseUrl,
                formFieldStates: [],
                applicationReferenceNumber,
            }).then(() => {
                navigate(
                    getPath(ConsumerLoanTargetPath.ongoing, languageCode, countryCode, applicationReferenceNumber),
                );
            });
        } else {
            navigate(
                getPath(
                    ConsumerLoanTargetPath.ongoing,
                    languageCode,
                    countryCode,
                    applicationReferenceNumber ?? undefined,
                ),
            );
        }
    }, [params, searchParams]);

    return <StatusProcessingPage />;
};

export default CallbackPage;
